module.exports = __webpack_public_path__ + "img/cvip.4f2f69d2.jpg";